/* eslint-disable */
import * as Types from './types';

import { CustomerWishlistFragmentDoc } from './CustomerWishlistFields';
import { useQuery, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '../../fetcher';
export type CustomerWishlistQueryVariables = Types.Exact<{
  customerAccessToken: Types.Scalars['String'];
}>;


export type CustomerWishlistQuery = { __typename?: 'QueryRoot', customer?: { __typename?: 'Customer', wishlistProducts?: { __typename?: 'Metafield', value: string, id: string } | null, wishlistNailArt?: { __typename?: 'Metafield', value: string, id: string } | null, wishlistArticles?: { __typename?: 'Metafield', value: string, id: string } | null } | null };

export declare const customerWishlist: import("graphql").DocumentNode;

export const CustomerWishlistDocument = /*#__PURE__*/ `
    query customerWishlist($customerAccessToken: String!) {
  customer(customerAccessToken: $customerAccessToken) {
    ...CustomerWishlistFragment
  }
}
    ${CustomerWishlistFragmentDoc}`;
export const useCustomerWishlistQuery = <
      TData = CustomerWishlistQuery,
      TError = unknown
    >(
      dataSource: { endpoint: string, fetchParams?: RequestInit },
      variables: CustomerWishlistQueryVariables,
      options?: UseQueryOptions<CustomerWishlistQuery, TError, TData>
    ) =>
    useQuery<CustomerWishlistQuery, TError, TData>(
      ['customerWishlist', variables],
      fetcher<CustomerWishlistQuery, CustomerWishlistQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CustomerWishlistDocument, variables, options),
      options
    );

useCustomerWishlistQuery.getKey = (variables: CustomerWishlistQueryVariables) => ['customerWishlist', variables];
;

useCustomerWishlistQuery.fetcher = (dataSource: { endpoint: string, fetchParams?: RequestInit }, variables: CustomerWishlistQueryVariables, options?: RequestInit['headers']) => fetcher<CustomerWishlistQuery, CustomerWishlistQueryVariables>(dataSource.endpoint, dataSource.fetchParams || {}, CustomerWishlistDocument, variables, options);